module.exports = __webpack_public_path__ + "img/student1.6f948c88.png";